import React, { useState, useEffect } from "react";
import { Select } from "@windmill/react-ui";
import VehicleCategoryServices from "services/VehicleCategoryServices";

const SelectVehicleCat = ({
  register,
  name,
  defaultValue,
  handleSeat,
  handleType,
  label,
  selectedOptions,
  ...props
}) => {
  const [allVehicleCategory, setVehicleCategory] = useState([]);
  const [selectedValue, setSelectedValue] = useState("");

  // Fetch vehicle categories on mount
  useEffect(() => {
    fetchVehicleCategory();
       // eslint-disable-next-line 
  }, []);
  async function fetchVehicleCategory() {
    try {
      const response = await VehicleCategoryServices.getAllVehicleCategory();

      const selectedVehicle = response.data.find(
        (category) => Number(category.id) === defaultValue
      );

      if (selectedVehicle) {
        
        handleSeat(selectedVehicle.seats);
      }
      setVehicleCategory(response.data);
    } catch (error) {
      console.error("Error fetching category:", error);
    }
  }
  // Initialize selectedValue with defaultValue
  useEffect(() => {
    if (defaultValue) {
      setSelectedValue(defaultValue);
      fetchVehicleCategory();
    }
       // eslint-disable-next-line 
  }, [defaultValue]);

  // Handle dropdown value changes
  const handleChange = (event) => {
    const selectedId = event.target.value;

    setSelectedValue(selectedId);

    // Find the selected vehicle category
    const selectedVehicle = allVehicleCategory.find(
      (category) => String(category.id) === String(selectedId)
    );

    // Propagate data to parent handlers
    if (selectedVehicle) {
      handleType(selectedVehicle.id);
      handleSeat(selectedVehicle.seats);
    } else {
      handleType("");
      handleSeat(null);
    }
  };

  return (
    <Select
      className="border h-10 text-sm focus:outline-none block w-full bg-white-100 dark:bg-white border-transparent focus:bg-white"
      name={name}
      value={selectedValue}
      {...register(name, { required: `${label} is required!` })}
      onChange={handleChange}
      {...props}
    >
      <option value="">Select Vehicle</option>
      {allVehicleCategory.length === 0 ? (
        <option>Loading...</option>
      ) : (
        allVehicleCategory.map((category) => (
          <option
            key={category.id}
            value={category.id}
            disabled={selectedOptions?.includes(String(category.id))}
          >
            {category.vehicle_type_name}
          </option>
        ))
      )}
    </Select>
  );
};

export default SelectVehicleCat;
